var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-login"},[_vm._v(" Loading..."+_vm._s(_vm.time)+"秒后自动跳转 "+_vm._s(_vm.authcode)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }